class Materials {
  constructor(api) {
    this.api = api;
  }

  getAll(queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_fibercloud
      .get("v1/stock-materials" + params)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getByUUID(uuid, queryParams = null, onSuccess, onError) {
    let append = "";
    if (queryParams) {
      append += "/?append=" + queryParams;
    }
    return this.api.http_fibercloud
      .get("v1/stock-materials/" + uuid + append)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/stock-materials", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  update(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/stock-materials", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  delete(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/stock-materials/" + uuid)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  deleteMultiple(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/stock-materials", { data: uuid })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  downloadAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/stock-materials/export/excel")
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  importMaterialFamilies(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/stock-materials/import/validation", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getHistory(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/imports?filter[type]=fc_stock_management_materials")
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }
}

export default Materials;



// WEBPACK FOOTER //
// ./src/api/materials.js